import STATES_JSON from "./states.json";
import CITIES_JSON from "./cities.json";

export const STATES = STATES_JSON;

export const SERVICES = [
  "Forward Exchange", "Reverse Exchange", "Improvement Exchange", "Personal Property Exchange",
  "DST / TIC Guidance", "Partnership / Drop & Swap", "Exchange Accommodation Titleholder (EAT)",
];

export const CERTIFICATIONS = ["CES®", "Attorney", "CPA", "Enrolled Agent", "CCIM", "Licensed Escrow Officer"];

export const GOALS = [
  "Get more investor leads", "Expand into new states", "Network with other QIs", "Find referral partners",
  "Build brand credibility", "Hire or partner with exchange staff", "Explore exchange software",
];

export const VOLUMES = ["Under 10", "10-50", "50-100", "100-250", "250+"];

export const PROFESSIONS = ["CPA", "Attorney", "Real Estate Broker / Agent", "Financial Advisor", "Lender", "Title / Escrow", "DST / TIC Sponsor", "Other"];

export const PROPERTY_VALUES = ["Under $500K", "$500K - $1M", "$1M - $5M", "$5M - $20M", "$20M+"];
export const TIMELINES = ["Already sold — on the 45-day clock", "Closing within 30 days", "1-3 months", "Just researching"];

export const stateName = (code) => STATES.find((s) => s[0] === code)?.[1] || code;

export const stateSlug = (code) => stateName(code).toLowerCase().replace(/\s+/g, "-");
export const stateFromSlug = (slug) => STATES.find(([c]) => stateSlug(c) === slug)?.[0];

export const CITIES = CITIES_JSON;
export const citySlug = (city) => city.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
export const cityPath = (city, code) => `/1031-exchange/${stateSlug(code)}/${citySlug(city)}`;
export const citiesIn = (code) => CITIES.filter(([, c]) => c === code);
export const cityFromSlug = (code, slug) => CITIES.find(([n, c]) => c === code && citySlug(n) === slug)?.[0];
